<template>
  <div class="child-card">
    <div class="child-card__content">
      <div class="child-card__avatar">
        <img class="img-fluid" src="@/assets/hometeacher/images/avatar-placeholder-male.png">
      </div><!-- /.child-card__avatar -->

      <h1 class="child-card__title">
        {{ child.name }}
      </h1>

      <div class="child-card__age">
        {{ displayAge }}
      </div>

      <div class="child-card__actions">
        <a
          class="child-card__edit"
          href="javascript:;"
          @click="edit=!edit"
        >
          {{ $t('change_data') }}
        </a>

        <a
          class="child-card__delete"
          href="javascript:;"
          @click="deleteItem"
        >
          <i class="fa fa-trash-alt"></i>
        </a>
      </div>
    </div><!-- /.child-card__content -->

    <form
      class="child-card-form"
      v-if="edit"
      @submit.prevent="updateItem"
    >
      <div class="form-group">
        <base-input
          required
          :placeholder="$t('student_name')"
          v-model="child.name"
        />
      </div>

      <div class="form-group">
        <base-date-picker
          required
          :placeholder="$t('birthday')"
          format="DD.MM.YYYY"
          v-model="birthday"
        />
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <button type="submit" class="btn btn-success">{{ $t('save') }}</button>
        </div>
        <div class="col-6 text-right">
          <a
            class="child-card__edit"
            href="javascript:;"
            @click="edit=!edit"
          >
            {{ $t('cancel') }}
          </a>
        </div>
      </div>
    </form>
  </div><!-- /.child-card -->
</template>

<script>
import moment from 'moment';

export default {
  name: 'ChildCard',

  props: {
    child: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      edit: false,
    }
  },

  computed: {
    age() {
      return moment().diff(moment(this.child.birth), 'years');
    },

    displayAge() {
      const cases = [2, 0, 1, 1, 1, 2];
      const words = [this.$t('year'), this.$t('years'), this.$t('years2')];
      if ((this.age % 100) > 4 && (this.age % 100) < 20) {
        return `${this.age} ${words[2]}`;
      } else {
        return `${this.age} ${words[cases[Math.min(this.age % 10, 5)]]}`;
      }
    },

    birthday: {
      get() {
        return moment(this.child.birth, 'YYYY-MM-DD').toDate();
      },
      set(value) {
        this.child.birth = moment(value).format('YYYY-MM-DD');
      }
    }
  },

  methods: {
    check() {
      return (this.child.name && /^\d{4}-\d{2}-\d{2}$/.test(this.child.birth));
    },

    updateItem() {
      if (this.check()) {
        this.edit = false;
        this.$emit('update', this.child);
      }
    },

    deleteItem() {
      if (confirm('Вы действительно хотите удалить ученика?')) {
        this.$emit('delete', this.child);
      }
    },
  }
}
</script>
